export const translations = {
  cookies: {
    sv: 'Cookies',
    en: 'Cookies',
    da: 'Cookies',
    fi: 'Evästeet',
    no: 'Cookies',
  },
  questions: {
    sv: 'Undrar du över något?',
    en: 'Do you have any questions?',
    da: 'Har du nogen spørgsmål?',
    fi: 'Onko sinulla kysyttävää?',
    no: 'Har du noen spørsmål?',
  },
  contact: {
    sv: 'Kontakta oss',
    en: 'Get in touch',
    da: 'Kontakt os',
    fi: 'Ota yhteyttä',
    no: 'Ta kontakt',
  },
  info: {
    sv: 'Mer information om PostNord hittar du på',
    en: 'More information about PostNord can be found at',
    da: 'Mere information om PostNord findes på',
    fi: 'Lisää tietoa PostNordista löydät osoitteesta',
    no: 'Du finner mer informasjon om PostNord på',
  },
  privacy: {
    sv: 'Integritetspolicy',
    en: 'Privacy policy',
    da: 'Integritetspolitik',
    fi: 'Yksityisyysasetukset',
    no: 'Privacy policy',
  },
  terms: {
    sv: 'Villkor',
    en: 'Terms and conditions',
    da: 'Vilkår og betingelser',
    fi: 'Sopimusehdot',
    no: 'Betingelser og vilkår',
  },
};
